// api/AuditsExportsTupDocumentsExport.ts
import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';

@Model()
class AuditsExportsTupDocumentsExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-tup_documents_exports';

  // Attributes
  @Attr() legalEntityId!: string;
  @Attr() deleteOldFiles!: boolean;

  // Extra-attributes

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
}

export default AuditsExportsTupDocumentsExport;
